import axios from "axios";


const apiHeroku = axios.create({
    baseURL: 'https://apisiacweb.herokuapp.com',
    headers: {
        Authorization: '01611596000129',
    },
});

export default apiHeroku;